import axios from '@/utils/axios'

export const GetSettings = async (country?: string, currency?: string) => {
  const params: Record<string, string> = {}
  
  if (country) {
    params.country = country
  }
  
  if (currency) {
    params.currency = currency
  }
  
  const { data } = await axios.get(
    process.env.NEXT_PUBLIC_API_URL + '/settings',
    { params }
  )
  
  return data
}